import { render, staticRenderFns } from "./UpgradeSubscription.vue?vue&type=template&id=12cbbcc5&"
import script from "./UpgradeSubscription.vue?vue&type=script&lang=js&"
export * from "./UpgradeSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports